import income from 'modules/invoicing/income/permissions';
import expense from 'modules/invoicing/expenses/permissions';
import links from 'modules/invoicing/links/permissions';
import { any } from 'core/permissions';

export const menu = {
  to: '/invoices',
  label: 'Invoices',
  icon: 'file-invoice-dollar' as const,
  children: [
    { to: '/invoices/income', label: 'Income', visible: income?.view },
    { to: '/invoices/expense', label: 'Expense', visible: expense?.view },
    { to: '/invoices/links', label: 'Link overview', visible: any(links.income, links.expense) },
  ],
};
